(function () {
  'use strict';

  var DATA_POLL_MS = 50;
  var DATA_POLL_LIMIT = 200;
  var pollCount = 0;
  var indexCache = null;

  function text(value) {
    return value == null ? '' : String(value);
  }

  function compare(a, b) {
    return text(a).localeCompare(text(b), undefined, { numeric: true, sensitivity: 'base' });
  }

  function unique(values) {
    return Array.from(new Set(values.filter(function (value) {
      return value !== null && value !== undefined && value !== '';
    }))).sort(compare);
  }

  function elements(root) {
    return {
      natural: root.querySelector('[data-bmc-natural]'),
      make: root.querySelector('[data-bmc-make]'),
      model: root.querySelector('[data-bmc-model]'),
      variant: root.querySelector('[data-bmc-variant]'),
      year: root.querySelector('[data-bmc-year]'),
      status: root.querySelector('[data-bmc-status]'),
      results: root.querySelector('[data-bmc-results]')
    };
  }

  function setStatus(els, message, isError) {
    els.status.textContent = message || '';
    if (isError) els.status.setAttribute('data-error', '');
    else els.status.removeAttribute('data-error');
  }

  function clearResults(els) {
    setStatus(els, '', false);
    els.results.replaceChildren();
  }

  function fillSelect(select, values, enabled) {
    var placeholder = select.getAttribute('data-placeholder') || 'Select';
    var fragment = document.createDocumentFragment();
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    fragment.appendChild(first);

    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = text(value);
      option.textContent = text(value);
      fragment.appendChild(option);
    });

    select.replaceChildren(fragment);
    select.disabled = enabled === false || values.length === 0;
  }

  function buildIndex(records) {
    var index = { makes: new Map() };

    records.forEach(function (record) {
      var make = text(record.make).trim();
      var model = text(record.model).trim();
      var variant = text(record.variant).trim();
      if (!make || !model) return;

      if (!index.makes.has(make)) index.makes.set(make, new Map());
      var models = index.makes.get(make);
      if (!models.has(model)) models.set(model, new Map());
      var variants = models.get(model);
      if (!variants.has(variant)) variants.set(variant, { years: new Set(), records: [] });

      var node = variants.get(variant);
      (Array.isArray(record.years) ? record.years : []).forEach(function (year) {
        node.years.add(text(year));
      });
      node.records.push(record);
    });

    return index;
  }

  function getIndex() {
    if (!indexCache) indexCache = buildIndex(window.BMC_FITMENTS || []);
    return indexCache;
  }

  function makeValues() {
    return Array.from(getIndex().makes.keys()).sort(compare);
  }

  function modelValues(make) {
    var models = getIndex().makes.get(make);
    return models ? Array.from(models.keys()).sort(compare) : [];
  }

  function variantValues(make, model) {
    var models = getIndex().makes.get(make);
    var variants = models && models.get(model);
    return variants ? Array.from(variants.keys()).sort(compare) : [];
  }

  function yearValues(make, model, variant) {
    var models = getIndex().makes.get(make);
    var variants = models && models.get(model);
    if (!variants) return [];

    var years = [];
    if (variant !== '') {
      var node = variants.get(variant);
      years = node ? Array.from(node.years) : [];
    } else {
      variants.forEach(function (node) {
        years = years.concat(Array.from(node.years));
      });
    }

    return unique(years).sort(function (a, b) { return Number(b) - Number(a); });
  }

  function titleFor(record) {
    return text(record.title || record.product_title || record.sku || 'BMC product');
  }

  function urlFor(record) {
    return text(record.url || record.product_url).trim();
  }

  function dedupeProducts(records) {
    var products = new Map();
    records.forEach(function (record) {
      var key = text(record.sku || urlFor(record) || titleFor(record));
      if (!products.has(key)) products.set(key, record);
    });
    return Array.from(products.values());
  }

  function renderResults(root, matches, selectionLabel) {
    var els = elements(root);
    var products = dedupeProducts(matches);
    els.results.replaceChildren();

    if (!products.length) {
      setStatus(els, root.getAttribute('data-no-results-message') || 'No confirmed compatible BMC filter was found.', true);
      return;
    }

    setStatus(els, products.length + ' compatible BMC product' + (products.length === 1 ? '' : 's') + ' found.', false);
    var fragment = document.createDocumentFragment();

    products.forEach(function (record) {
      var card = document.createElement('article');
      card.className = 'vehicle-finder__result';

      var heading = document.createElement('h3');
      heading.className = 'vehicle-finder__result-title';
      heading.textContent = titleFor(record);
      card.appendChild(heading);

      var meta = document.createElement('p');
      meta.className = 'vehicle-finder__result-meta';
      var details = [];
      if (record.sku) details.push('SKU: ' + record.sku);
      if (record.category) details.push(record.category);
      meta.textContent = details.join(' · ');
      card.appendChild(meta);

      if (selectionLabel) {
        var fitment = document.createElement('p');
        fitment.className = 'vehicle-finder__result-fitment';
        fitment.textContent = selectionLabel;
        card.appendChild(fitment);
      }

      var url = urlFor(record);
      if (url) {
        var link = document.createElement('a');
        link.className = 'button vehicle-finder__result-link';
        link.href = url;
        link.textContent = root.getAttribute('data-view-product-label') || 'View product';
        card.appendChild(link);
      }

      fragment.appendChild(card);
    });

    els.results.appendChild(fragment);
  }

  function findStructured(root) {
    var els = elements(root);
    var make = els.make.value;
    var model = els.model.value;
    var variant = els.variant.value;
    var year = els.year.value;

    if (!make || !model || !year) {
      setStatus(els, root.getAttribute('data-incomplete-message') || 'Select a manufacturer, model and year.', true);
      els.results.replaceChildren();
      return;
    }

    var matches = window.BMC_FITMENTS.filter(function (record) {
      return text(record.make) === make &&
        text(record.model) === model &&
        (!variant || text(record.variant) === variant) &&
        (Array.isArray(record.years) ? record.years.map(text) : []).indexOf(year) !== -1;
    });

    var selection = [make, model, variant, year].filter(Boolean).join(' · ');
    renderResults(root, matches, selection);
  }

  function findNatural(root) {
    var els = elements(root);
    var query = text(els.natural.value).trim().toLowerCase();
    if (!query) return false;

    var tokens = query.split(/\s+/).filter(Boolean);
    var matches = window.BMC_FITMENTS.filter(function (record) {
      var haystack = [
        record.make,
        record.model,
        record.variant,
        (Array.isArray(record.years) ? record.years : []).join(' '),
        record.sku,
        titleFor(record),
        record.category
      ].join(' ').toLowerCase();

      return tokens.every(function (token) { return haystack.indexOf(token) !== -1; });
    });

    renderResults(root, matches, 'Search: ' + els.natural.value.trim());
    return true;
  }

  function reset(root) {
    var els = elements(root);
    els.natural.value = '';
    fillSelect(els.make, makeValues(), true);
    fillSelect(els.model, [], false);
    fillSelect(els.variant, [], false);
    fillSelect(els.year, [], false);
    clearResults(els);
  }

  function initialise(root) {
    if (!root || root.getAttribute('data-bmc-ready') === 'true') return;
    var els = elements(root);
    if (!els.natural || !els.make || !els.model || !els.variant || !els.year || !els.status || !els.results) return;

    root.setAttribute('data-bmc-ready', 'true');
    reset(root);
  }

  function initialiseAll(scope) {
    (scope || document).querySelectorAll('[data-bmc-vehicle-finder]').forEach(initialise);
  }

  function waitForData() {
    if (Array.isArray(window.BMC_FITMENTS)) {
      getIndex();
      initialiseAll(document);
      return;
    }

    pollCount += 1;
    if (pollCount < DATA_POLL_LIMIT) {
      window.setTimeout(waitForData, DATA_POLL_MS);
      return;
    }

    document.querySelectorAll('[data-bmc-vehicle-finder]').forEach(function (root) {
      var els = elements(root);
      if (els.status) setStatus(els, root.getAttribute('data-load-error') || 'Vehicle fitment data could not be loaded.', true);
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    var root = target.closest && target.closest('[data-bmc-vehicle-finder]');
    if (!root || !Array.isArray(window.BMC_FITMENTS)) return;
    var els = elements(root);

    if (target.matches('[data-bmc-make]')) {
      fillSelect(els.model, modelValues(els.make.value), true);
      fillSelect(els.variant, [], false);
      fillSelect(els.year, [], false);
      clearResults(els);
    } else if (target.matches('[data-bmc-model]')) {
      var variants = variantValues(els.make.value, els.model.value);
      fillSelect(els.variant, variants, true);
      fillSelect(els.year, yearValues(els.make.value, els.model.value, ''), true);
      clearResults(els);
    } else if (target.matches('[data-bmc-variant]')) {
      fillSelect(els.year, yearValues(els.make.value, els.model.value, els.variant.value), true);
      clearResults(els);
    } else if (target.matches('[data-bmc-year]')) {
      clearResults(els);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-bmc-find], [data-bmc-reset]');
    if (!button) return;
    var root = button.closest('[data-bmc-vehicle-finder]');
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.matches('[data-bmc-reset]')) {
      reset(root);
      return;
    }

    clearResults(elements(root));
    if (!findNatural(root)) findStructured(root);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches('[data-bmc-natural]')) return;
    var root = event.target.closest('[data-bmc-vehicle-finder]');
    if (!root) return;
    event.preventDefault();
    clearResults(elements(root));
    findNatural(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (Array.isArray(window.BMC_FITMENTS)) initialiseAll(event.target);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForData, { once: true });
  else waitForData();
}());
